import Joi from 'joi'
import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'
import CommonSchema from '../commonSchema'

const ApiMixinFiles = {
  async apiFileHHD(
    arg = {
      method: '',
      params: {},
      formData: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'query':
        const schemaQuery = Joi.object().keys({
          siteId: Joi.string()
            .max(100)
            .required(),
          keyWord: Joi.string()
            .allow('')
            .max(100)
            .optional(),
          url: Joi.string()
            .allow('')
            .max(100)
            .optional(),
          createdTime: Joi.array()
            .optional()
            .notes(
              ' [\n' +
                '      {\n' +
                '        "dateTime": "string",\n' +
                '        "operator": "string"\n' +
                '      }\n' +
                '    ]'
            ),
          lastModifiedTime: Joi.array()
            .optional()
            .notes(
              ' [\n' +
                '      {\n' +
                '        "dateTime": "string",\n' +
                '        "operator": "string"\n' +
                '      }\n' +
                '    ]'
            ),
        })
        const dataPage = CommonSchema.dataPageValidate(arg.params.dataPage)
        const orderBy = CommonSchema.orderByValidate(arg.params.orderBy)
        const queryValidateRes = Joi.validate(arg.params.where, schemaQuery)
        if (queryValidateRes.error) {
          ;[err, res] = [
            {
              message: '请求参数错误',
              details: queryValidateRes.error.details,
            },
            false,
          ]
        } else {
          ;[err, res] = await To(
            wizStandardInstance.post('/file/query_files_hdd', {
              where: queryValidateRes.value,
              dataPage,
              orderBy,
            })
          )
        }
        break
      case 'upload':
        ;[err, res] = await To(wizStandardInstance.post('/file/upload_files_hdd', arg.formData))
        break
      case 'download':
        ;[err, res] = await To(wizStandardInstance.post('/file/download_files', arg.params))
        break
      case 'delete':
        const schemaDelete = Joi.object().keys({
          md5List: Joi.array().items(Joi.string()),
        })
        const deleteValidateRes = Joi.validate(arg.params, schemaDelete)
        if (deleteValidateRes.error) {
          ;[err, res] = [
            {
              message: '请求参数错误',
              details: deleteValidateRes.error.details,
            },
            false,
          ]
        } else {
          ;[err, res] = await To(
            wizStandardInstance.delete('/file/delete_files_hdd', {
              data: deleteValidateRes.value.md5List,
            })
          )
        }
        break
      default:
        return console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiFileContent(
    arg = {
      method: {},
      params: {},
    }
  ) {
    let [err, res] = [null, null]
    const schemaContent = Joi.object().keys({
      md5: Joi.string()
        .alphanum()
        .max(30)
        .required(),
    })
    const contentValidateRes = Joi.validate(arg.params, schemaContent)
    if (contentValidateRes.error) {
      ;[err, res] = [
        {
          message: '请求参数错误',
          details: contentValidateRes.error.details,
        },
        false,
      ]
    } else {
      ;[err, res] = await To(
        wizStandardInstance.get(
          encodeUrl(`/file/getfilecontentasync/${contentValidateRes.value.md5}`)
        )
      )
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  // 分片相关
  async apiFileUpload(
    arg = {
      method: '',
      params: {},
      formData: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'getmaxchunk':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/DocumentFile/getmaxchunk/${arg.params.siteId}/${arg.params.documentId}/${arg.params.fileName}/${arg.params.md5}/${arg.params.totalChunk}/${arg.params.origin}/${arg.params.size}`
          )
        )
        break
      case 'chunkupload':
        ;[err, res] = await To(
          wizStandardInstance.post(
            `/api/DocumentFile/chunkuploadasync/${arg.params.fileId}/${arg.params.index}`,
            arg.formData
          )
        )
        break
      case 'merge':
        ;[err, res] = await To(
          wizStandardInstance.post(
            `/api/DocumentFile/chunkuploadasync/${arg.params.fileId}`,
            arg.formData
          )
        )
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiBaseFile(
    arg = {
      method: '',
      params: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'delete':
        ;[err, res] = await To(
          wizStandardInstance.delete('/api/BaseData/attachment', {
            data: arg.params,
          })
        )
        break
      default:
        console.log('no method')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
}
export default {
  methods: ApiMixinFiles,
}
